import React, { useState } from "react";
import HeaderBanner from "../../Components/HeaderBanner/HeaderBanner";
import "./booking.css";
import FadeInWhenVisible from "../../Utilities/FadeInWhenVisible";
import DeliveryMethodSelector from "../../Components/DeliveryMethodSelector/DeliveryMethodSelector";
import { openWhatsAppChat } from "../../Utilities/whatsapp";

export default function BookingPage() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [location, setLocation] = useState("");
  const [message, setMessage] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deliveryMethods, setDeliveryMethods] = useState({
    email: true,
    whatsapp: false,
  });

  const timeSlots = [
    "10:00 am",
    "10:30 am",
    "11:00 am",
    "11:30 am",
    "12:00 pm",
    "12:30 pm",
    "1:00 pm",
    "1:30 pm",
    "2:00 pm",
    "2:30 pm",
    "3:00 pm",
    "3:30 pm",
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const resetForm = () => {
      setFirstName("");
      setLastName("");
      setEmail("");
      setPhone("");
      setLocation("");
      setMessage("");
      setSelectedDate("");
      setSelectedTime("");
    };

    if (deliveryMethods.whatsapp) {
      openWhatsAppChat(
        [
          "New Booking Request",
          `Name: ${firstName} ${lastName}`,
          `Email: ${email}`,
          `Phone: ${phone}`,
          `Location: ${location}`,
          `Date: ${selectedDate}`,
          `Time Slot: ${selectedTime}`,
          `Message: ${message || "N/A"}`,
        ].join("\n")
      );
    }

    if (!deliveryMethods.email) {
      setIsConfirmationModalOpen(true);
      resetForm();
      setIsSubmitting(false);
      return;
    }

    const payload = {
      _subject: `New Booking from ${firstName} ${lastName}`,
      "First Name": firstName,
      "Last Name": lastName,
      "Email": email,
      "Phone": phone,
      "Location": location,
      "Selected Date": selectedDate,
      "Time Slot": selectedTime,
      "Message": message,
    };

    fetch("https://formsubmit.co/ajax/zakarry540@gmail.com", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => response.json())
    .then(data => {
      setIsConfirmationModalOpen(true);
      resetForm();
    })
    .catch((err) => {
      console.error("Submission failed", err);
      alert("Failed to submit booking. Please try again.");
    })
    .finally(() => setIsSubmitting(false));
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  };

  return (
    <div>
      <HeaderBanner title="Booking Page" currentPath="Bookings" />
      <div className="booking">
        <FadeInWhenVisible delay={0.2}>
          <div className="booking-form">
            <h6 className="small-header">Book Us</h6>
            <h1>Book Your Schedule</h1>
            <form onSubmit={handleSubmit}>
              <div className="input-break">
                <input
                  type="text"
                  placeholder="First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
                <input
                  type="text"
                  placeholder="Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </div>
              <div className="input-break">
                <input
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
              <input
                type="text"
                placeholder="Your Location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                required
              />
              <textarea
                placeholder="Booking Message (optional)"
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <label className="label">
                Select a Date <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="date"
                value={selectedDate}
                placeholder="Your Location"
                onChange={(e) => setSelectedDate(e.target.value)}
                className="input-text calendar-input"
                required
              />

              <label className="label">
                Select a Time Slot <span style={{ color: "red" }}>*</span>
              </label>
              <div className="time-slots">
                {timeSlots.map((slot) => (
                  <button
                    type="button"
                    key={slot}
                    className={`time-slot ${
                      selectedTime === slot ? "selected" : ""
                    }`}
                    onClick={() => setSelectedTime(slot)}
                  >
                    {slot}
                  </button>
                ))}
              </div>

              <DeliveryMethodSelector
                methods={deliveryMethods}
                onChange={setDeliveryMethods}
              />

              <button type="submit" className="submit-btn" disabled={isSubmitting}>
                {isSubmitting ? "SUBMITTING..." : "SUBMIT BOOKING"}
              </button>
            </form>
            {isConfirmationModalOpen && (
              <div className="modal">
                <div className="modal-submitted">
                  <p>Thank you for booking Us.</p>
                  <p>We'll be in touch with you soon.</p>
                  <button
                    className="confirm-btn"
                    onClick={closeConfirmationModal}
                  >
                    CLOSE
                  </button>
                </div>
              </div>
            )}
          </div>
        </FadeInWhenVisible>
      </div>
    </div>
  );
}
